<template>
  <div ref="mychart" class="chart-container"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'MultiLineChart',
  props: {
    seriesData: {
      type: Array,
      required: true
      // 格式举例：[ { name: '系列1', data: [10,20,…] }, {...}, {...} ]
    },
    xAxisLabels: {
      type: Array,
      required: true
      // 举例：['01-01', '01-02', …]
    }
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    // this.initChart()
    //   window.addEventListener('resize', this.resize)
    setTimeout(() => {
      this.initMyChart()
      const resizeOb = new ResizeObserver((entries) => {
        for (const entry of entries) {
          echarts.getInstanceByDom(entry.target).resize()
        }
      })
      resizeOb.observe(this.$refs.mychart)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
    if (this.chart) this.chart.dispose()
  },
  watch: {
    deep: true,
    seriesData() {
      this.initMyChart() // 重置图表
    }
  },
  methods: {
    initMyChart() {
      let mychart = echarts.getInstanceByDom(this.$refs.mychart)
      if (mychart == null) mychart = echarts.init(this.$refs.mychart)

      const total = this.xAxisLabels.length
      const showCount = 3 // 默认显示最后 3 个
      const startIndex = total > showCount ? total - showCount : 0
      const endIndex = total - 1

      const option = {
        tooltip: {
          trigger: 'axis',
          confine: true // 确保不超出容器
        },
        legend: {
          data: this.seriesData.map((s) => s.name),
          textStyle: { color: '#005eb8', fontSize: 12 }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '14%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.xAxisLabels,
          axisLabel: {
            fontSize: 10,
            color: '#333',
            interval: 0,
            rotate: 15
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: { color: '#333', fontSize: 10 },

          axisLine: { lineStyle: { color: '#005eb8' } }
        },
        dataZoom: [
          {
            type: 'slider',
            realtime: true,
            height: 5,
            left: 5,
            right: 5,
            bottom: 10,
            show: total > showCount,
            fillerColor: 'rgba(17, 100, 210, 0.42)',
            borderColor: 'rgba(17, 100, 210, 0.12)',
            handleSize: 0,
            showDetail: false,
            zoomLock: true,
            moveOnMouseMove: false,

            // ✅ 重点设置
            startValue: startIndex,
            endValue: endIndex,
            minValueSpan: showCount,
            maxValueSpan: showCount
          },
          {
            type: 'inside',
            startValue: startIndex,
            endValue: endIndex,
            zoomOnMouseWheel: false,
            moveOnMouseWheel: true,
            moveOnMouseMove: true
          }
        ],
        series: this.seriesData.map((s) => ({
          name: s.name,
          type: 'line',
          data: s.data,
          smooth: true,
          lineStyle: {
            width: 2
          }
        }))
      }

      mychart.setOption(option, true)

      // ✅ 强制刷新数据缩放状态，确保生效（某些情况下有必要）
      this.$nextTick(() => {
        mychart.dispatchAction({
          type: 'dataZoom',
          startValue: startIndex,
          endValue: endIndex
        })
      })
    },

    // initMyChart() {
    //   let mychart = echarts.getInstanceByDom(this.$refs.mychart)
    //   if (mychart == null) mychart = echarts.init(this.$refs.mychart)
    //   const option = {
    //     tooltip: {
    //       trigger: 'axis'
    //     },
    //     legend: {
    //       data: this.seriesData.map((s) => s.name),
    //       textStyle: { color: '#005eb8' }
    //     },
    //     grid: {
    //       left: '3%',
    //       right: '4%',
    //       bottom: '3%',
    //       top: '14%',
    //       containLabel: true
    //     },
    //     xAxis: {
    //       type: 'category',
    //       data: this.xAxisLabels,
    //       axisLabel: {
    //         color: '#005eb8',
    //         interval: 0,
    //         rotate: 15 // 旋转角度
    //       }
    //     },
    //     yAxis: {
    //       type: 'value',
    //       axisLabel: { color: '#005eb8' },
    //       axisLine: { lineStyle: { color: '#005eb8' } }
    //     },
    //     dataZoom: [
    //       {
    //         type: 'slider',

    //         realtime: true,
    //         start: 0,
    //         end: 10, // 数据窗口范围的结束百分比。范围是：0 ~ 100。
    //         height: 5, //组件高度
    //         left: 5, //左边的距离
    //         right: 5, //右边的距离
    //         bottom: 10, //下边的距离
    //         show: this.xAxisLabels.length > 4, // 是否展示
    //         fillerColor: 'rgba(17, 100, 210, 0.42)', // 滚动条颜色
    //         borderColor: 'rgba(17, 100, 210, 0.12)',
    //         handleSize: 0, //两边手柄尺寸
    //         showDetail: false, //拖拽时是否展示滚动条两侧的文字
    //         zoomLock: true, //是否只平移不缩放
    //         moveOnMouseMove: false, //鼠标移动能触发数据窗口平移
    //         //zoomOnMouseWheel: false, //鼠标移动能触发数据窗口缩放

    //         //下面是自己发现的一个问题，当点击滚动条横向拖拽拉长滚动条时，会出现文字重叠，导致效果很不好，以此用下面四个属性进行设置，当拖拽时，始终保持显示六个柱状图，可结合自己情况进行设置。添加这个属性前后的对比见**图二**
    //         startValue: 0, // 从头开始。
    //         endValue: 3, // 最多六个
    //         minValueSpan: 3, // 放大到最少几个
    //         maxValueSpan: 3 //  缩小到最多几个
    //       },
    //       {
    //         type: 'inside', // 支持内部鼠标滚动平移
    //         start: 0,
    //         end: 10,
    //         zoomOnMouseWheel: false, // 关闭滚轮缩放
    //         moveOnMouseWheel: true, // 开启滚轮平移
    //         moveOnMouseMove: true // 鼠标移动能触发数据窗口平移
    //       }
    //     ],
    //     series: this.seriesData.map((s) => ({
    //       name: s.name,
    //       type: 'line',
    //       data: s.data,
    //       smooth: true,
    //       lineStyle: {
    //         width: 2
    //       }
    //     }))
    //   }
    //   mychart.setOption(option, true)
    // },
    resize() {
      this.chart && this.chart.resize()
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-container {
  width: 100%;
  height: 100%;
}
</style>
